import { createRequest } from '@direct-frontend/modules-request';

/**
 * Запросы к геокодеру
 */
export const request = createRequest({
    baseUrl: () => 'https://suggest-maps.yandex.ru/v1/suggest',
    timeout: { connect: 100, request: 1000 },
    agent: false,
    retry: 2,
});
